<template>
  <div :class="{ 'fix-nav': navBarFixed }">
    <div id="nav" class="top-nav">
      <div class="nav-logo-box">
        <img :src="require('../assets/image_1/logo.png')"  @click="link('/index')"/>
        <div class="nav-logo-box-line"></div>
        <div class="logo-txt">一站式数字化技术营销服务商</div>
      </div>
      <div class="font-list">
        <span class="font" @click="indexTo" :class="{ 'active-nav': $route.path == '/index' }">首页</span>
        <span class="font" @mouseenter="show"   :class="{ 'active-nav': $route.path == '/product' || $route.path == '/exploit'||$route.path == '/communication' || $route.path == '/middleground' ||$route.path=='/contract'}">产品服务
          <!-- <span class="iconfont icon-icon_down1" :class="[isactive ? 'is-transform' : 'not-transform']"></span> -->
        </span>
        <!-- <span class="font" @click="openDialog">方案报价</span> -->
        <span class="font"
          @click="toLink('https://www.yunzmall.com/plugins/shop_server/home?i=10')">应用市场</span>
        <span class="font" @click="cooperation" :class="{ 'active-nav': $route.path == '/cooperation' }">加盟合作</span>
        <!-- <span class="font"
          @click="toLink('https://www.yunzmall.com/plugins/shop_server/articleContent/425?i=10')">关于芸众</span> -->
        <span class="font" @click="link('/about')" :class="{ 'active-nav': $route.path == '/about' }">关于芸众</span>
      </div>
      <!-- <div class="nav-right" @click="openDialog">
        <img
          src="../assets/nav-logo3.png"
          alt=""
          srcset=""
          style="margin-right: 5px"
        />
        <span>演示</span>
      </div> -->
      <div @click="toLink('https://www.yunzmall.com/plugins/shop_server/download?i=10&fromLogin=1')" class="dowonload">
        免费下载
      </div>
    </div>
    <div class="pull-content" v-show="isactive" @mouseleave="isactive = false;">
      <div class="pull-content-box" @mouseenter="handleMouseEnter(1)" @mouseleave="handleMouseLeave"  @click="link('/product')">
        <!-- <a href="https://www.yunzmall.com/dist/#/product"> -->
          <template v-if="isHovered && current_nav == 1">
            <img :src="require('../assets/image_1/popup_active_1.png')" />
            <div class="pull-content-tips-active">
              <div class="mb-15 font-bold">智慧商城系统</div>
              <div>实现企业线上化数字经营</div>
            </div>
          </template>
          <template v-else>
            <img :src="require('../assets/image_1/popup_1.png')" />
            <div class="pull-content-tips">智慧商城系统</div>
          </template>
        <!-- </a> -->
      </div>
      <div class="pull-content-box" @mouseenter="handleMouseEnter(2)" @mouseleave="handleMouseLeave" @click="link('/middleground')">
        <template v-if="isHovered && current_nav == 2">
          <img :src="require('../assets/image_1/popup_active_2.png')" />
          <div class="pull-content-tips-active">
            <div class="mb-15 font-bold">供应链中台系统</div>
            <div>实现企业规模化生态经营</div>
          </div>
        </template>
        <template v-else>
          <img :src="require('../assets/image_1/popup_2.png')" />
          <div class="pull-content-tips">供应链中台</div>
        </template>
      </div>
      <div class="pull-content-box" @mouseenter="handleMouseEnter(3)" @mouseleave="handleMouseLeave" @click="link('/communication')">
        <template v-if="isHovered && current_nav == 3">
          <img :src="require('../assets/image_1/popup_active_3.png')" />
          <div class="pull-content-tips-active">
            <div class="mb-15 font-bold">数据通系统</div>
            <div>实现企业数据化聚合分发</div>
          </div>
        </template>
        <template v-else> <img :src="require('../assets/image_1/popup_3.png')" />
          <div class="pull-content-tips">数据通系统</div>
        </template>
      </div>
      <div class="pull-content-box" @mouseenter="handleMouseEnter(4)" @mouseleave="handleMouseLeave" @click="link('/contract')">
        <template v-if="isHovered && current_nav == 4">
          <img :src="require('../assets/image_1/popup_active_4.png')" />
          <div class="pull-content-tips-active">
            <div class="mb-15 font-bold">电子合同系统</div>
            <div>实现企业数字化合规经营</div>
          </div>
        </template>
        <template v-else>
          <img :src="require('../assets/image_1/popup_4.png')" />
          <div class="pull-content-tips">电子合同系统</div>
        </template>
      </div>
      <div class="pull-content-box" @mouseenter="handleMouseEnter(5)" @mouseleave="handleMouseLeave"
        @click="link('/exploit')">

        <template v-if="isHovered && current_nav == 5">
          <img :src="require('../assets/image_1/popup_active_5.png')" />
          <div class="pull-content-tips-active">
            <div class="mb-15 font-bold">定制开发</div>
            <div>实现企业个性化特色经营</div>
          </div>
        </template>
        <template v-else>
          <img :src="require('../assets/image_1/popup_5.png')" />
          <div class="pull-content-tips">定制开发</div>
        </template>
      </div>


      <!-- <div class="pull-content-top">
        <strong style="color: #203df5; font-size: 18px">企业级智慧电商系统</strong>
        <div style="
            display: inline-block;
            margin-left: 20px;
            color: #203df5;
            font-size: 14px;
            padding: 10px;
            background-color: #eff5ff;
            border-radius: 16px;
          ">
          线上做生意，找芸众科技
        </div>
        <div class="system-list">
          <div class="system-list-item system-list-product" v-for="(item, index) in systemList1" :key="index"
            @click="productTo">
            <img :src="item.img" alt="">
            <strong class="system-list-title">{{ item.title }}</strong>
            <div class="list-info">
              <div class="list-info-item" v-for="(items, index) in item.list" :key="index">
                <div class="point"></div>{{ items }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pull-content-bottom">
        <strong style="color: #203df5; font-size: 18px">企业项目落地运营服务</strong>
        <div style="
            display: inline-block;
            margin-left: 20px;
            color: #203df5;
            font-size: 14px;
            padding: 10px;
            background-color: #ffffff;
            border-radius: 16px;
          ">
          高效合规
        </div>
        <div class="system-list">
          <div class="system-list-item" v-for="(item, index) in systemList2" :key="index">
            <img :src="item.img" alt="">
            <strong class="system-list-title">{{ item.title }}</strong>
            <div class="list-info">
              <div class="list-info-item" v-for="(items, index) in item.list" :key="index">
                <div class="point"></div>{{ items }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="background: linear-gradient(282deg, rgba(6,216,251,0.07) 0%, #203DF5 100%);">
        <div class="pull-content-logo">
          承接个性化定制开发 · 解决企业数字化转型全方位技术需要
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isactive: false,
      systemList1: [
        {
          img: require("../assets/list1.png"),
          title: '通用商城解决方案',
          list: ['品牌B2C商城', 'B2B2C商城', '分销商城']
        },
        {
          img: require("../assets/list2.png"),
          title: '新零售商城解决方案',
          list: ['团队极差商城系统', '链动新商店', '微商云库存']
        },
        {
          img: require("../assets/list3.png"),
          title: '单门店商城解决方案',
          list: ['在线项目预约系统', 'POS收银买单系统', '共享股东系统']
        },
        {
          img: require("../assets/list4.png"),
          title: 'O2O多商户解决方案',
          list: ['异业联盟多商户', '连锁店商城', '共享股东系统']
        },
        {
          img: require("../assets/list5.png"),
          title: '企业管理系统',
          list: ['项目管理系统', '电子合同系统', '律师平台系统']
        },
        {
          img: require("../assets/list6.png"),
          title: '知识付费商城解决方案',
          list: ['在线视频点播系统', '线下活动报名', '付费文档商城系统']
        },
        {
          img: require("../assets/list7.png"),
          title: '供应链商城系统',
          list: ['胜天半子供应链商城', '聚合CPS商城系统', '供应链中台商城系统']
        },
        {
          img: require("../assets/list8.png"),
          title: '供应链中台',
          list: ['产品供应链中台系统解决方案', '内容运营中台解决方案', 'CPS中台解决方案']
        },
      ],
      systemList2: [
        {
          img: require("../assets/list9.png"),
          title: '运营策划',
          list: ['品牌全案服务', '创始人/品牌IP打造服务', '产品策划服务', '活动策划服务']
        },
        {
          img: require("../assets/list10.png"),
          title: '运维服务',
          list: ['单台服务器托管运维', '集群部署运维托管服务', '服务器迁移服务']
        },
        {
          img: require("../assets/list11.png"),
          title: '商城装修拍摄',
          list: ['商品拍摄服务', '店铺首页基础设计服务', '商品主图设计服务']
        },
        {
          img: require("../assets/list12.png"),
          title: '云连锁策划运营',
          list: ['抖音云连锁策划服务', '私域云连锁全托管运营']
        },
      ],
      navBarFixed: false,
      current_nav: '',
      isHovered: true,
    };
  },

  methods: {
    link(url){
      let path = this.$route.path;
      if(url==path){
        return;
      }
      this.$router.push({path:url});
      window.scrollTo(0, 0);
    },
    handleMouseEnter(current_nav) {
      this.current_nav = current_nav
      this.isHovered = true;
    },
    handleMouseLeave() {
      this.current_nav = 0;
      this.isHovered = false;
    },
    show() {
      this.isactive = true;
      this.check_nav_bar()
    },
    openDialog() {
      this.$emit('openDialog')
    },
    watchScroll() {
      // 滚动的距离   
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 容器的高度  
      var offsetTop = document.querySelector("#nav").offsetHeight;
      if (scrollTop > offsetTop) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    toLink(url) {
      window.open(url)
    },
    productTo() {
      if (this.$route.path !== '/product') {
        this.isactive = false;
        this.$router.push({ path: 'product' })
      }

    },
    cooperation() {
      // if(this.$route.path !== '/cooperation') {
      //   this.isactive = false;
      //   this.$router.push({path:'cooperation'})
      // }
      this.$navigate('push', 'cooperation'); // 跳转到详情页并传递参数
        window.scrollTo(0, 0);
    },
    indexTo() {
      if (this.$route.path !== '/index') {
        this.isactive = false;
        this.$router.push({ path: 'index' })
        window.scrollTo(0, 0);
      }

    },
    check_nav_bar() {
      let path = this.$route.path;
      this.isHovered = true;
      console.log(this.current_nav,'===',path);
      if (path === '/exploit') {
        this.current_nav = 5;
      }else if(path == '/communication'){
        this.current_nav = 3;
      }else if(path=='/middleground'){
        this.current_nav = 2;
      }else if(path=='/contract'){
        this.current_nav = 4
      }else if(path=='/product')
        this.current_nav = 1
    }
  },
  mounted() {
    // 事件监听滚动条  
    window.addEventListener("scroll", this.watchScroll);
    this.check_nav_bar()
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.watchScroll);
  },
  components: {},
};

</script>
<style scoped lang="scss">
.logo-txt {
  font-weight: 400;
  font-size: 18px;
  color: #091221;
}

.current {
  color: #007EFF !important;
}

.nav-logo-box-line {
  width: 0;
  height: 28px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #707070;
  margin-right: 10px;
  margin-left: 10px;
}

.company-name-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 11px;
  margin-right: 11px;
}

.company-name {
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  color: #091221;
}

.nav-logo-box {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.dowonload {
  width: 109px;
  height: 35px;
  background: #091221;
  border-radius: 18px 18px 18px 18px;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  line-height: 35px;
  margin-left: 43px;
  cursor: pointer;
}

.top-nav {
  height: 67px;
  /* margin: 10px 250px; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.font-list {
  margin-left: 115px;
  line-height: 40px;
}

.active-nav {
  font-weight: bold !important;
  font-size: 18px !important;
  color: #007EFF !important;
}

.font {
  font-weight: 400;
  font-size: 18px;
  color: #091221;
  margin-left: 42px;
  cursor: pointer;
}

.font:hover {
  /* padding-bottom: 5px;
  border-bottom: 1px solid #203df5; */
  color: #007EFF;
}

.icon-icon_down1 {
  position: absolute;
  font-weight: 400;
}

.is-transform {
  transform: rotate(180deg);
  transition: transform 0.2s;
  /* color:#203CF5;
  background:#203CF5 ; */
}

.not-transform {
  transform: rotate(360deg);
  transition: transform 0.2s;
}

.nav-right {
  width: 76px;
  height: 32px;
  border-radius: 17px;
  background-color: rgb(32, 61, 245);
  margin-left: 80px;
  margin-top: 5px;
  color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-right:hover {
  opacity: 0.7;
  cursor: pointer;
}

.pull-content-box {
  margin-right: 30px;
  position: relative;
  cursor: pointer;

  .mb-15 {
    margin-bottom: 15px;
  }

  .font-bold {
    font-weight: bold;
  }

  .pull-content-tips-active {
    position: absolute;
    bottom: 30px;
    left: 20px;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    text-align: left;
  }

  img {
    display: block;
  }

  .pull-content-tips {
    position: absolute;
    bottom: 31px;
    left: 20px;
    font-weight: bold;
    font-size: 20px;
    color: #091221;

  }
}

.pull-content {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 99;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 40px;
  padding-top: 52px;
}

.pull-content-top {
  padding: 22px 40px;
  background-color: #ffffff;
}

.pull-content-bottom {
  padding: 22px 40px;
  background-color: #EFF5FF;
}

.pull-content-logo {
  background-image: url("../assets/background1.png");
  height: 100px;
  line-height: 100px;
  padding-left: 40px;
  font-size: 24px;
  color: #ffffff;
}

.system-list {
  padding-left: 20px;
  display: flex;
  flex-wrap: wrap;
}

.system-list-title {
  margin-left: 10px;
  font-size: 16px;
}

.list-info {
  margin-top: 10px;
  margin-left: 10px;
}

.list-info-item {
  margin-bottom: 10px;
  color: #000000;
  opacity: 0.6;
  font-size: 12px;
  font-weight: 500;
}

.point {
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: #3E85FF;
  opacity: 0.2;
  border-radius: 100%;
  margin-right: 13px;
}

.system-list-item {
  margin-right: 100px;
  width: calc((100% - 340px) / 4);
  margin-top: 20px;

}

.system-list-product {
  cursor: pointer;
}

.system-list-item:nth-child(4n) {
  margin-right: 0;
}

.fix-nav {
  position: fixed;
  z-index: 100;
  width: 100%;
  background-color: #ffffff;
  top: 0;
}
</style>